// //////////////////////////////////////////////////////////////////////////////////
// CONSTANTS
// //////////////////////////////////////////////////////////////////////////////////

export const ADD_PB_FIELD = 'ADD_PB_FIELD'
export const REMOVE_PB_FIELD = 'REMOVE_PB_FIELD'
export const SET_PB_FIELD_VALUE = 'SET_PB_FIELD_VALUE'
export const SET_PB_PROFILE = 'SET_PB_PROFILE'
export const RESET_PB_STATE = 'RESET_PB_STATE'

// //////////////////////////////////////////////////////////////////////////////////
// ACTIONS
// //////////////////////////////////////////////////////////////////////////////////

// //////////////////////////////////////////////////////////////////////////////////
// REDUCER
// //////////////////////////////////////////////////////////////////////////////////

const initialState = {
	// fields: [field, Object.assign({}, field, {row: {value: 2}, col: {value: 12}}), Object.assign({}, field)],
	fields: [],
	profile: {},
}

export default function reducer(state = initialState, action) {
	const fields = state.fields.slice()
	let meta
	let data
	let profile

	switch (action.type) {
		case ADD_PB_FIELD:
			fields.push(action.payload)
			return { ...state, fields }

		case SET_PB_FIELD_VALUE:
			// eslint-disable-next-line prefer-destructuring
			meta = action.payload.meta
			// eslint-disable-next-line prefer-destructuring
			data = action.payload.data
			fields[meta.index][meta.field] = data
			return { ...state, fields }

		case REMOVE_PB_FIELD:
			fields.splice(action.payload, 1)
			return { ...state, fields }

		case SET_PB_PROFILE:
			// eslint-disable-next-line prefer-destructuring
			meta = action.payload.meta
			// eslint-disable-next-line prefer-destructuring
			data = action.payload.data
			profile = { ...state.profile, [meta.field]: data }
			return { ...state, profile }

		case RESET_PB_STATE:
			return { ...initialState }

		default:
			return state
	}
}
